import tippy from "tippy.js";

$(document).ready(function () {

    var tooltips = (function () {

        var init = function () {
            // addEventListeners();

            tippy('[data-tippy-content]');

            return;
        };

        // var addEventListeners = function () {
        //
        //     $('[data-tooltip]').on('click', handleTooltip);
        // }
        //
        // var handleTooltip = function() {
        //     let tooltip = $(this).data('tooltip');
        //
        //     tippy($(this), {
        //         content: tooltip,
        //     });
        // }

        return {
            init: init
        }

    })();

    tooltips.init();

});



